<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 sales-delivery-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ $t("SALES_DELIVERIES.EDIT_SALES_DELIVERY") }}
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <sales-delivery-form
              :loading="loading"
              :salesDeliveryData="salesDelivery"
              :formErrors="formErrors"
              @salesDeliveriesubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import SalesDeliveryForm from "./partials/SalesDeliveryForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultSalesDelivery from "./defaultSalesDelivery";

export default {
  layout: "DashboardLayout",

  components: { SalesDeliveryForm },

  mixins: [alertLeave],

  data() {
    return {
      salesDelivery: cloneDeep(defaultSalesDelivery),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("salesDeliveries/get", id);
        this.salesDelivery =
          this.$store.getters["salesDeliveries/salesDelivery"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List SalesDeliveries" });
    },

    viewSalesDelivery() {
      this.alertLeave = false;
      this.$router.push({
        name: "View SalesDelivery",
        params: { id: this.salesDelivery.id },
      });
    },

    async handleSubmit(salesDelivery) {
      this.loading = true;
      const salesDeliveryData = cloneDeep(salesDelivery);
      if (salesDeliveryData.sourceWarehouse) {
        if (!salesDeliveryData.sourceWarehouse.id) {
          delete salesDeliveryData.sourceWarehouse;
        }
      }
      try {
        await this.$store.dispatch("salesDeliveries/update", salesDeliveryData);
        this.$notify({
          type: "success",
          message: this.$t("SALES_DELIVERIES.SALES_DELIVERY_UPDATED"),
        });
        this.viewSalesDelivery();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
